const state = {
  showDialog: false,
  checkedGroup: {},
}

const actions = {
  async reverseShowDialog({ commit }, status) {
    commit('REVERSE_SHOW_DIALOG', status)
  },
}

const mutations = {
  REVERSE_SHOW_DIALOG(state, status) {
    state.showDialog = status;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
